import Vue from 'vue'
import Vuex from 'vuex'

import authUser from './modules/AuthUser'
import register from './modules/Register'
import auth from './modules/Auth'
import service from './modules/Service'
import group from './modules/Group'
import user from './modules/User'
import routine from './modules/Routine'
import routineGroup from './modules/RoutineGroup'
import routineRef from './modules/RoutineRef'
import routineSelf from './modules/RoutineSelf'
import routineData from './modules/RoutineData'
import chatRef from './modules/ChatRef'
import chatMessage from './modules/ChatMessage'
import dispatch from './modules/Dispatch'
import chatStatics from './modules/ChatStatics'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authUser,
    register,
    auth,
    service,
    group,
    user,
    routine,
    routineGroup,
    routineRef,
    routineSelf,
    routineData,
    chatRef,
    chatMessage,
    dispatch,
    chatStatics
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js